import { Config } from '../models';

const REACT_APP_PREFIX = 'REACT_APP_';

export class Configuration {
  processEnv = process.env ?? {};

  windowEnv: Config = (window as any).__env__ ?? {};

  config: Config = {} as Config;

  constructor(settings: Config = {} as Config) {
    // Same keys will be overwritten in the order of below spreads
    this.config = {
      ...this.windowEnv, // from public/config.js
      ...this.getCleanProcessEnv(), // from .env file
      ...settings, // from parent; can be from a backend server
    };
  }

  // Remove react app prefix for easier merging
  // Ex. REACT_APP_apiUrl becomes apiUrl
  private getCleanProcessEnv() {
    return Object.entries(this.processEnv).reduce(
      (cleanProcessEnv: any, [key, value]) => {
        cleanProcessEnv[key.replace(REACT_APP_PREFIX, '')] = value;
        return cleanProcessEnv;
      },
      {} as Config,
    );
  }
}
